import { createContext, useContext } from 'react'

/** @type {import('react').Context<{ socket: import('socket.io-client').Socket }>} */
export const roomContext = createContext({})

function useRoomContext() {
    return useContext(roomContext)
}
export default useRoomContext
